import { type NextBestAction } from '@post-office/confluence-next-best-action';
import { defaultMessageBackend } from '@post-office/placement-common-v2';
import {
	PlacementBackend,
	PlacementFrontend,
} from '@post-office/placements--growth/confluence-side-nav';

import { ResurrectedUserWelcomeMessage } from './message';
import { assertMessageTemplateContext } from '../../../__generated__/validation/messageTemplateContext';
import { type MessageTemplateContext } from '../../../index';

// Shouldn't need to change message before sending to frontend
export const MessageBackend = PlacementBackend.createMessageBackend(defaultMessageBackend);

type MessageFrontendProps = MessageTemplateContext & {
	onSideNavClick: (nextBestActionType: NextBestAction) => string | void | null;
	handleOnDismissed: () => void;
};

export const MessageFrontend = PlacementFrontend.createMessageFrontend({
	render: {
		validate: assertMessageTemplateContext,
		Component: ({
			nextBestActionType,
			onSideNavClick,
			handleOnDismissed,
		}: MessageFrontendProps) => {
			return (
				<ResurrectedUserWelcomeMessage
					onSideNavClick={onSideNavClick}
					handleOnDismissed={handleOnDismissed}
					nextBestActionType={nextBestActionType}
				/>
			);
		},
	},
});
